/**
 * Jeton CSRF des actions d'écriture de l'interface (App\Security\Csrf\RequireCsrfToken), posé par
 * base.html.twig dans window.SCORIMMO_CONFIG.csrfToken.
 *
 * - appels jQuery qui écrivent (POST, PUT, DELETE…) vers le site : l'en-tête est ajouté
 *   automatiquement ;
 * - fetch : passer csrfHeaders() dans les en-têtes ;
 * - lien qui déclenche une action : `<a href="…" data-csrf-post>` ou submitPost(url) depuis un
 *   gestionnaire (confirmation préalable par exemple), qui envoie un vrai formulaire POST.
 */
export const CSRF_HEADER = 'X-CSRF-Token';

export function csrfToken()
{
    const token = window.SCORIMMO_CONFIG?.csrfToken;
    if (!token) {
        console.error('Jeton CSRF absent de window.SCORIMMO_CONFIG : les actions d\'écriture seront refusées (403).');
    }

    return token ?? '';
}

export function csrfHeaders()
{
    return {[CSRF_HEADER]: csrfToken()};
}

/**
 * Envoie un formulaire POST (navigation normale) vers url, avec le jeton et les champs donnés.
 *
 * @param {string} url
 * @param {Object<string, string>} fields
 */
export function submitPost(url, fields = {})
{
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    for (const [name, value] of Object.entries({...fields, _token: csrfToken()})) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
}

function isSameOrigin(url)
{
    return new URL(url, window.location.href).origin === window.location.origin;
}

$.ajaxPrefilter((options, originalOptions, xhr) => {
    if (!/^(GET|HEAD|OPTIONS)$/i.test(options.type) && isSameOrigin(options.url)) {
        xhr.setRequestHeader(CSRF_HEADER, csrfToken());
    }
});

$(document).on('click', 'a[data-csrf-post]', function (event) {
    event.preventDefault();
    submitPost(this.href);
});
